import { RECENT_EMOJIS_STORAGE_KEY } from "../portalChat.constants";
import type { PortalChatStorage } from "./platform";

/** Quick-reaction shortcuts (PRD: open emoji set; these are shortcuts into it). */
export const QUICK_EMOJIS = ["👍", "❤️", "😂", "😮", "😢", "🙏"];

/** How many recently-used emojis persist across sessions. */
export const RECENT_EMOJIS_MAX = 12;

/** Curated dependency-free grid; both pickers (web Popover, mobile bottom sheet) render it. */
export const EMOJI_GROUPS: { label: "Smileys" | "Gestures" | "Objects"; emojis: string[] }[] = [
  {
    label: "Smileys",
    emojis: [
      "😀",
      "😃",
      "😄",
      "😁",
      "😆",
      "😅",
      "😂",
      "🤣",
      "😊",
      "😇",
      "🙂",
      "😉",
      "😍",
      "🥰",
      "😘",
      "😗",
      "😜",
      "🤪",
      "🤔",
      "🤨",
      "😐",
      "😑",
      "😶",
      "🙄",
      "😏",
      "😴",
      "😪",
      "🤤",
      "😷",
      "🤒",
      "🤕",
      "🥳",
      "😎",
      "🤓",
      "🧐",
      "😕",
      "😟",
      "🙁",
      "😮",
      "😯",
      "😲",
      "😳",
      "🥺",
      "😢",
      "😭",
      "😤",
      "😠",
      "😡",
    ],
  },
  {
    label: "Gestures",
    emojis: [
      "👍",
      "👎",
      "👌",
      "✌️",
      "🤞",
      "🤟",
      "🤘",
      "👏",
      "🙌",
      "👐",
      "🤝",
      "🙏",
      "💪",
      "👊",
      "✊",
      "🤚",
      "👋",
      "🤙",
      "👈",
      "👉",
      "👆",
      "👇",
      "☝️",
      "✋",
    ],
  },
  {
    label: "Objects",
    emojis: [
      "❤️",
      "🧡",
      "💛",
      "💚",
      "💙",
      "💜",
      "🖤",
      "💔",
      "💯",
      "🔥",
      "⭐",
      "🌟",
      "✨",
      "⚡",
      "☀️",
      "🌈",
      "🎉",
      "🎊",
      "🏆",
      "🥇",
      "📌",
      "📎",
      "📁",
      "📄",
      "🗓️",
      "⏰",
      "🚀",
      "🏗️",
      "🏢",
      "🔧",
      "🛠️",
      "⚙️",
    ],
  },
];

/** Read the persisted recently-used list (MRU, deduped, capped). Bad/absent data → empty. */
export function readRecentEmojis(storage: PortalChatStorage): string[] {
  try {
    const parsed: unknown = JSON.parse(storage.getItem(RECENT_EMOJIS_STORAGE_KEY) ?? "[]");
    return Array.isArray(parsed) ? parsed.filter((entry): entry is string => typeof entry === "string") : [];
  } catch {
    return [];
  }
}

/** MRU-insert `emoji`, persist, and return the new list. */
export function pushRecentEmoji(storage: PortalChatStorage, recent: string[], emoji: string): string[] {
  const next = [emoji, ...recent.filter((e) => e !== emoji)].slice(0, RECENT_EMOJIS_MAX);
  storage.setItem(RECENT_EMOJIS_STORAGE_KEY, JSON.stringify(next));
  return next;
}
